import { dashboardURL } from '../../context/API';

// Dashboard URL utilities
export const getDashboardUrl = (token: string, role: string, hostname: string): string => {
  const isProduction = hostname.includes('kiwikrave.com');
  return isProduction
    ? `${dashboardURL}/dashboard?access_token=${token}&role=${role}`
    : `/dashboard?access_token=${token}&role=${role}`;
};

export const getRoleFromHostname = (hostname: string): string => {
  return hostname.includes('admin') ? 'admin' : 'merchant';
};

// OTP Constants
export const MAX_OTP_REQUESTS = 5;
export const RESEND_COOLDOWN = 60; // 1 minute in seconds
export const RESET_TIME = 3600; // 1 hour in seconds

export const formatOtpExpiry = (expiresAt: string | undefined | null): string => {
  if (!expiresAt) return '';
  try {
    const diffMs = new Date(expiresAt).getTime() - Date.now();
    if (diffMs <= 0) return 'Code expired';

    const diffMins = Math.floor(diffMs / 60000);
    const diffSecs = Math.floor((diffMs % 60000) / 1000);
    return diffMins > 0 ? `Code expires in ${diffMins}m ${diffSecs}s` : `Code expires in ${diffSecs}s`;
  } catch (e) {
    return '';
  }
};
